import { render } from "./MessageGroupPage.vue?vue&type=template&id=3bcef127"
import script from "./MessageGroupPage.vue?vue&type=script&lang=js"
export * from "./MessageGroupPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__